import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertTemplateVariablesMutation, InsertTemplateVariablesMutationVariables } from '@/graphql/generated/graphql';
import { InsertTemplateVariablesDocument } from '@/graphql/generated/graphql';
export type TemplateVariableInsertInput = {
  OrganizationIds?: string[]
  TemplateId?: string
  ParentId?: string
  Token?: string
  Name?: string
  Label?: string
  Type?: string
  Required?: boolean
  Placeholder?: string
  HelpText?: string
  Options?: string[]
  DefaultValue?: string
  Format?: string
  TypeMeta?: string
  Order?: number
  SourceSpan?: string
  UilmLabelKey?: string
  UilmPlaceholderKey?: string
  UilmHelpTextKey?: string
  UilmOptionsKeys?: string[]
}

export type InsertTemplateVariableResponse = {
  data: {
    insertTemplateVariables: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertTemplateVariable = () => {
  const mutation = useMutation({
    mutationKey: ['insert-template-variable'],
    mutationFn: (variables: TemplateVariableInsertInput) => {
      return graphqlClient.request<InsertTemplateVariablesMutation>(InsertTemplateVariablesDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertTemplateVariable: mutation.mutate,
    insertTemplateVariableAsync: mutation.mutateAsync,
  }
}

export const INSERT_TEMPLATE_VARIABLE_MUTATION = InsertTemplateVariablesDocument;
